export const MAIN_WINDOW_NAME = "taui-main-window";
